import { Observer } from "mobx-react";
import { Message } from "primereact/message";
import React from "react";
import styled from "styled-components";
import { useLocStore } from "../../wsLocalization";
import { LocContext } from "../../wsLocalization/LocContext";

export interface CVEditInvalidStateReminderProps {
  showReminder: () => boolean;
}
export const CVEditInvalidStateReminder = ({
  showReminder,
}: CVEditInvalidStateReminderProps) => {
  const L = useLocStore(LocContext.CV);

  return (
    <Observer
      render={() => {
        if (!showReminder()) return null;

        return (
          <CVEditInvalidStateReminderStyles
            className="cve-editor-invalid-state-reminder"
            severity="error"
            text={L.id("bf518967c088").loc(
              "En eller flere felter inneholder feil"
            )}
          />
        );
      }}
    />
  );
};

const CVEditInvalidStateReminderStyles = styled(Message)`
  &.cve-editor-invalid-state-reminder.cve-editor-invalid-state-reminder.cve-editor-invalid-state-reminder {
    margin: 0.25rem;
    width: auto;
    flex-grow: 1;
  }
`;
